import { isServer } from "./global";
import config from "./config";
import Cookies from "js-cookie";

export const dropExistingUserCookie = () => {
  if (isServer()) {
    return;
  }

  const expires = new Date();
  expires.setFullYear(2030);
  Cookies.set("dc_user_existing", "1", {
    expires,
    domain: config.COOKIE_DOMAIN,
    secure: true
  });
};

export const floodlightTrack = (path: string, activity: string) => {
  if (isServer()) {
    return;
  }

  if (!window.gtag) {
    return;
  }

  window.gtag("event", "conversion", {
    allow_custom_scripts: true,
    u1: path,
    send_to: `DC-${config.FLOODLIGHT_CONFIG_ID}/echocoun/${activity}+unique`
  });
};
